import { createReducer, on } from '@ngrx/store'
import { ISeguridad } from '@shared/interfaces/app.state.interfaces'
import { seguridad } from '../actions/seguridad.actions'

export const initialState: ISeguridad = {
    token: '',
    user: ''
}

// {
//     "id": 1,
//     "name": "Prueba Prueba",
//     "email": "Prueba33@gmail.com",
//     "idUsuario": "33",
//     "idAportante": "33",
//     "opcion": 1
// }

export const seguridadReducer = createReducer(
    initialState,
    on(seguridad, ((state, { item }) => {
        return { ...state, token: item.token, user: item.user }
    }))
)